// ControlDatePickerFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import DatePickerControlView from 'common-inputs/DateCalendarControlView.js';

//=============================================================================
//
// Creates a date picker (date calendar) control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 8, 2015 
//
//=============================================================================
class ControlDateCalendarFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {
		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		//adding silent(accessibility) to attributes.
		attributes.silent = false;
		attributes.styleColorText ='~inputTextColor';
		attributes.fontFamily = '~inputFont';
		attributes.fontSize = '~inputFont';
		attributes.textWeight = '~inputFont';
		attributes.textStyle  = '~inputFont';
		attributes.borderStyle= '~inputBorder';
		attributes.borderSize= '~inputBorder';
		attributes.cornerRadius= '~inputBorder';
		attributes.borderColor = '~inputBorderColor';
		attributes.styleBGColorText = '~inputBgColor';
		attributes.backgroundColor = '~inputBgColor';
		attributes.dateValue = '';
		attributes.specific = '';
        attributes.resizePadding = 2;
		attributes.minWidth = 142;
		attributes.minHeight = 140;
		attributes.lowestHeight = 140;
		attributes.showNow = 'true';
		attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

		return new DatePickerControlView ( {
        	model: new ControlModel( attributes ), 
        	el: $(constants.FORM_ID),  
			pos: pos, 
			factoryKey: factoryKey, 
			id: attributes.id } );
	}

}

const controlDatePickerFactory = new ControlDateCalendarFactory();
export default controlDatePickerFactory;
